import { h } from '../lib/dom.js';
import { getState } from '../store.js';
import { closeProfileMenu, switchProfile, goAddProfile } from '../actions.js';
import { iconMarkup } from '../icons/index.js';

export function renderProfileMenu() {
  const s = getState();
  if (!s.showProfileMenu) return null;

  const rows = s.profiles.map((p) =>
    h('button', {
      class: 'btn profile-row-btn ' + (p.id === s.activeProfileId ? 'btn-primary' : 'btn-secondary'),
      onclick: () => switchProfile(p.id)
    }, [
      h('span', { html: iconMarkup(p.avatar || 'circleUserRound', { size: 16 }) }),
      p.name
    ])
  );

  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, 'Switch profile'),
      h('div', { class: 'stack' }, rows),
      h('button', { class: 'btn btn-secondary', onclick: goAddProfile }, [
        h('span', { html: iconMarkup('circlePlus', { size: 14 }) }), ' Add profile'
      ]),
      h('button', { class: 'btn btn-secondary text-muted', onclick: closeProfileMenu }, 'Close')
    ])
  ]);
}
